"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pick = _interopRequireDefault(require("lodash/pick"));

var _propTypes = require("prop-types");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _utils.wrapValidator)(function (config) {
  return function (props, prop, compName) {
    var propNames = Object.keys(config);
    var values = Object.values((0, _pick.default)(props, propNames)).filter(function (value) {
      return value !== undefined;
    });

    if (!!values.length && values.length !== propNames.length) {
      var names = (0, _utils.quotedNames)(propNames);
      return new Error("Component \"".concat(compName, "\" requires that all or none of [").concat(names, "] are provided."));
    }

    (0, _propTypes.checkPropTypes)(config, props, 'prop', compName);
    return null;
  };
});

exports.default = _default;